import {
  HTTP_YEAR_FETCHING,
  HTTP_YEAR_SUCCESS,
  HTTP_YEAR_FAILED,
  server,
  OK,
  YES,
} from "././../../Constants";
import { httpClient } from "./../../utils/HttpClient";

export const setYearStateToFetching = () => ({
  type: HTTP_YEAR_FETCHING,
});

export const setYearStateToSuccess = (payload) => ({
  type: HTTP_YEAR_SUCCESS,
  payload,
});
export const setYearStateToFailed = (payload) => ({
  type: HTTP_YEAR_FAILED,
});

export const getYear = (orgcode) => {
  return async (dispatch) => {
    dispatch(setYearStateToFetching());

    try {
      const result = await httpClient.get(`${server.YEAR_URL}/${orgcode}`, {
        headers: {
          authorization: `Bearer ${localStorage.getItem("token")}`,
        },
      });

      if (result.data) {
        dispatch(setYearStateToSuccess(result.data));
      } else {
        dispatch(setYearStateToSuccess([]));
      }
    } catch (error) {
      dispatch(setYearStateToFailed());
    }
  };
};

// export const year = (history, credential) => {
//   return (dispatch) => {
//     dispatch(setYearStateToFetching());
//     setTimeout(() => {
//       dispatch(setYearStateToSuccess({ result: "ok" }));
//     }, 3000);
//     // dispatch(setBudgetStateToFailed)
//   };
// };

// export const getYear = () => {
//   return dispatch => {
//     dispatch(setYearStateToFetching());
//     goGetYear(dispatch);
//   };
// };

// const goGetYear = async dispatch => {
//   try {
//     const result = await httpClient.get(server.YEAR_URL);
//     dispatch(setYearStateToSuccess(result.data));

//   } catch (error) {
//     dispatch(setYearStateToFailed());
//   }
// };
